import React from "react";
import { FormattedMessage } from "react-intl";
import Typography from "@material-ui/core/Typography";
import Icon from "components/icon";
import IconButton from "components/icon-button";
import withStyles from "components/with-styles";
import styles from "./styles/locale-info.css.js";

const LocaleInfo = withStyles(styles)(({ classes, locale, onClick }) => {
    return (
            <IconButton color="inherit" onClick={onClick}>
            <div className={classes.icon}>
                <Icon name="language"/>
            </div>
            <Typography variant="body1">
                <FormattedMessage id={`common.locale.in.${locale}`}/>
            </Typography>
            <Icon name="keyboard-arrow-down"/>
        </IconButton>
        )
    }
);

export default LocaleInfo;
